import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class McpAuthService {
  openConsentPopup(consentLink: string, threadId: string): Observable<void> {
    return new Observable(subscriber => {
      const popup = window.open(consentLink, 'mcp-oauth', 'width=600,height=700');

      if (!popup) {
        subscriber.error(new Error('Popup blocked'));
        return;
      }

      let completed = false;

      const complete = () => {
        if (completed) return;
        completed = true;
        cleanup();
        subscriber.next();
        subscriber.complete();
      };

      const onMessage = (event: MessageEvent) => {
        if (event.data?.type === 'mcp_auth_complete') {
          // Accept if threadId matches or if the callback doesn't include one
          if (!event.data?.threadId || event.data?.threadId === threadId) {
            complete();
          }
        }
      };

      // Fallback: resolve when the popup closes itself (backend callback calls window.close()).
      // The brief delay lets the backend finish storing the OAuth token before we re-send.
      let closedTimer: ReturnType<typeof setTimeout> | null = null;
      const poll = setInterval(() => {
        if (popup.closed && !closedTimer) {
          closedTimer = setTimeout(complete, 1500);
        }
      }, 500);

      window.addEventListener('message', onMessage);

      const cleanup = () => {
        clearInterval(poll);
        if (closedTimer) clearTimeout(closedTimer);
        window.removeEventListener('message', onMessage);
        if (!popup.closed) popup.close();
      };

      return cleanup;
    });
  }
}
